var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"button",staticClass:"cta",class:_vm.classes,style:(_vm.styles),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_c('span',{staticClass:"cta__shadow"}),_vm._v(" "),_c('span',{staticClass:"cta__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }